import React from 'react'
import CurrentUser from 'components/CurrentUser'
import { Redirect } from 'react-router-dom'
import { ExternalButtonLink, spacer } from 'stylist'
import { signInUri } from 'utils/unifiedLogin'
import styled from 'react-emotion'

const LoginPromptContainer = styled.div`
  max-width: 500px;
  margin: ${spacer(4)};
`

const LoginPromptPage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`

const RouteLoggedOut = ({ location: { pathname } }) => (
  <CurrentUser
    render={currentUser =>
      currentUser ? (
        <Redirect to="/" replace />
      ) : (
        <LoginPromptPage>
          <LoginPromptContainer>
            <h3>Looks like you're not signed in!</h3>
            <h4>Click below to get started.</h4>
            <ExternalButtonLink href={signInUri(pathname)} kind="primary" block>
              Sign In
            </ExternalButtonLink>
          </LoginPromptContainer>
        </LoginPromptPage>
      )
    }
  />
)

export default RouteLoggedOut



// WEBPACK FOOTER //
// ./src/routes/logged-out.js